import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { ListingParams } from '../../_models/common/listingParams';
import { StatusCode, SelectionType } from '../../_enums/Common';
import { CommonService } from '@services/app.common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SystemListingPageField } from '../../interface/appDataView/app-data-view.interface';


@Component({
    selector: 'app-lookupdataview',
    templateUrl: './app-LookupDataView.component.html',
    standalone: false
})
export class LookupDataViewComponent implements OnInit {

  @Output() byClick: EventEmitter<any> = new EventEmitter();
  @Output() byLoaded: EventEmitter<any> = new EventEmitter();

  @Input() inputParams = {} as ListingParams;

  public pageFields: SystemListingPageField[] =[];;
  public listOfData:any;
  public properties:any;
  public pageNo = 1;
  public isAllChecked = false;

  public totalRows: number = 0;
  public totalPages: number = 0;

  public showingRecordStart:number=0;
  public showingRecordEnd:number=0;
  public RefId:string = "";
  public StatusCode = StatusCode;
  public isSingleSelection = false;
  public isMultipleSelection = false;
  public selectedRecord:any;

  constructor(private common: CommonService, public loader: NgxSpinnerService) {
  }

  ngOnInit() {
    this.inputParams = this.common.initListingParams();
    this.inputParams.textToSearch = '';
    this.inputParams.idToSearch = 0;

    this.isSingleSelection = this.inputParams.selectionType == SelectionType.Single;
    this.isMultipleSelection = this.inputParams.selectionType == SelectionType.Multiple;

    this.getListOfData();
  }

  public getListOfData() {
    this.loader.show();
    this.inputParams.sortDirection = this.inputParams.isAscendingSort ? 'ASC' : 'DESC';
    this.inputParams.selectionType == SelectionType.Multiple;
    let params = {
      IsAscendingSort: this.inputParams.isAscendingSort,
      SortColumn: this.inputParams.sortColumn,
      PageSize: this.inputParams.pageSize,
      Skip: ((this.pageNo - 1) * this.inputParams.pageSize),
      IdToSearch: this.inputParams.idToSearch ? this.inputParams.idToSearch : 0,
      TextToSearch: this.inputParams.textToSearch,
      SystemPageId: this.inputParams.systemPageId,
      ScreenName: this.inputParams.screenName,
      ControllerName: this.inputParams.controllerName,
      SearchOptions: this.inputParams.searchOptions,
      CandidateId: this.inputParams.candidateId,
      SortDirection: this.inputParams.sortDirection,
      showArchived: this.inputParams.showArchived,
      action: 'List'
    };
    let startLoader = true;

    this.common.PostData(this.inputParams.getUrl, params, startLoader).then(data => {
      let response = data;
      if (response.status == this.StatusCode.OK) {
        this.pageFields = response.resultData.headerData;
        this.listOfData = response.resultData.listData;
        this.RefId = response.resultData.refId;
        this.totalRows = response.resultData.count;
        this.totalPages = Math.ceil(this.totalRows / this.inputParams.pageSize);
        this.showingRecordStart = ((this.pageNo - 1) * this.inputParams.pageSize) + 1;
        this.showingRecordEnd = (this.pageNo * this.inputParams.pageSize);
        if (this.showingRecordEnd > this.totalRows) {
          this.showingRecordEnd = this.totalRows;
        }
        if (this.listOfData[0] != null) {
          this.properties = Object.getOwnPropertyNames(this.listOfData[0]);
        }

      }
      this.byLoaded.emit();
    });
  }

  public getTotalPagesList() {
    let array = new Array();
    for (let i = 1; i <= this.totalPages; i++) {
      array.push(i);
    }
    return array;
  }

  public switchPage(pageNo:number) {
    if (pageNo <= this.totalPages && pageNo >= 1 && pageNo != this.pageNo) {
      this.pageNo = pageNo;
      //document.getElementById('cmbpageno').nodeValue = pageNo;
      this.getListOfData();
    }
  }

  public selectPage(event: Event) {
    let input = event.target as HTMLInputElement;
    this.pageNo = parseInt(input.value);
    this.getListOfData();
  }

  public selectAllCheckBox(event: Event) {
    let input = event.target as HTMLInputElement;
    this.isAllChecked = input.checked;
    this.listOfData.forEach((item:any) => item.checked = this.isAllChecked);
  }

  public toggleCheckBox(data: any, value: boolean) {
    data.checked = !value;
    this.isAllChecked = this.listOfData.every((item:any) => item.checked);
  }

  public toggleRadioButton(data:any) {
    this.selectedRecord = data;
  }

  public SortData(columnName:string, isSortAble:number) {
    if (isSortAble) {
      if (this.inputParams.sortColumn == columnName) {
        this.inputParams.isAscendingSort = !this.inputParams.isAscendingSort;
      } else {
        this.inputParams.isAscendingSort = true;
        this.inputParams.sortColumn = columnName;
      }
      this.getListOfData();
    }
  }

  public OnClick(fieldData:any, id:number, obj:any) {
    fieldData = this.common.JsonParseData(fieldData);
    fieldData.id = id;
    fieldData.obj = obj;
    this.byClick.emit(fieldData);
  }

  public GetSelectedItems(): Array<any> {
    let selectedRecords = new Array();

    if (this.isSingleSelection) {
      if (this.selectedRecord) {
        selectedRecords.push(this.selectedRecord);
      }
    } else {
      this.listOfData.forEach(function (value:any) {
        if (value.checked) {
          selectedRecords.push(value);
        }
      });
    }

    return selectedRecords;
  }
}
